/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Api_Key_DescriptionInputs */



/**
* | output |
* | --- |
* | "Authentication key for the endpoint. Stored encrypted." |
*
* @param {Private_Models_Form_Api_Key_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_api_key_description = /** @type {((inputs?: Private_Models_Form_Api_Key_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Api_Key_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Authentifizierungsschlüssel für den Endpunkt. Wird verschlüsselt gespeichert.")
	return /** @type {LocalizedString} */ ("Authentication key for the endpoint. Stored encrypted.")
});